<template>
  <a-spin :spinning="confirmLoading">
    <a-form :form="form">
      <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.roleName">
        <a-input v-decorator="['roleName', validatorRules.roleName]"
                 :read-only="checkField('roleName')"
                 @click="openLangModal('roleName', true)"
                 :placeholder="$t('label.pleaseEnterRoleName')" />
      </mtc-form-item>
      <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.roleCode">
        <a-input :placeholder="$t('label.pleaseEnterRoleCode')"
                 :disabled="!!model.id"
                 v-decorator="['roleCode', validatorRules.roleCode]" />
      </mtc-form-item>
    </a-form>
  </a-spin>
</template>

<script>
import { mtcLangModalMixin } from '@/mixins/mtcLangModalMixin'
import langInputMixin from '@/mixins/langInputMixin'
import { addRole, duplicateCheck, editRole } from '@api/api'
import { resetLangFieldMap, setLangInputParams } from '@/utils/langUtils'

export default {
  name: 'RoleForm',
  title: '角色新建编辑表单',
  mixins: [mtcLangModalMixin, langInputMixin],
  data() {
    return {
      // 表名
      mainTable: 'sys_role',
      // 校验规则
      validatorRules: {
        roleName: {
          rules: [
            { required: true, message: this.$t('label.pleaseEnterRoleName') },
            { min: 2, max: 30, message: this.$t('label.twoToThirtyCharactersInLength'), trigger: 'blur' }
          ]
        },
        roleCode: {
          rules: [
            { required: true, message: this.$t('label.pleaseEnterRoleCode') },
            { min: 0, max: 64, message: this.$t('label.upToSixtyFourCharactersInLength'), trigger: 'blur' },
            { validator: this.validateRoleCode }
          ]
        },
        description: {
          rules: [{ min: 0, max: 126, message: this.$t('label.LessThanCharacters_126'), trigger: 'blur' }]
        }
      }
    }
  },
  methods: {
    // 角色编码校验方法
    validateRoleCode(rule, value, callback) {
      if (/[\u4E00-\u9FA5]/g.test(value)) {
        callback(this.$t('label.noChineseCharactersAllowed'))
      } else {
        var params = {
          tableName: 'sys_role',
          fieldName: 'role_code',
          fieldVal: value,
          dataId: this.model.id
        }
        duplicateCheck(params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback(res.message)
          }
        })
      }
    },
    submitForm() {
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          values.roleName = (values.roleName || '').trim()
          values.roleCode = (values.roleCode || '').trim()
          let formData = Object.assign(this.model, values)
          let obj = editRole
          console.log(formData)
          // 设置数据多语言参数
          formData.sysLanguageList = setLangInputParams(this.mainTable, formData.id)
          if (!this.model.id) {
            obj = addRole
            this.$emit('ok', formData)
            return
          }
          this.confirmLoading = true
          obj(formData).then(res => {
            if (!res.success) return
            resetLangFieldMap()
            this.$message.success(res.message)
            this.$emit('ok')
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          return err
        }
      })
    }
  }
}
</script>